'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFile, iconFileTag } from '@ni/nimble-components/dist/esm/icons/file';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFile };
export { iconFileTag };
export const NimbleIconFile = wrap(IconFile);